<template>
    <div >
        <div class="progress " style="height:auto;cursor:pointer;"
            @mousedown="start"
            @mouseleave="cancel"
            @mouseup="cancel"
            @click="cancel"
            @touchstart.prevent="start"
            @touchend="cancel"
            
        >
            <div v-if="state=='press'" class=" progress-bar progress-bar-striped progress-bar-animated" :style="{width:progress+'%',padding:'1.5rem 0 1.5rem 0 !important'}"  role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100">
                <h2 class="">{{slotText}}</h2>
                <div>{{slotSmall}}</div>
            </div>
            <div v-if="state=='redeemed'" class="p-4 progress-bar progress-bar-striped progress-bar-animated bg-success" :style="'width:100%'" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                <h2>{{slotText}}</h2>
                <div>{{slotSmall}}</div>
            </div>
            <div v-if="state=='error'" class="p-4 progress-bar progress-bar-striped progress-bar-animated bg-danger" :style="'width:100%'" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                <h2>{{slotText}}</h2>
                <div>{{slotSmall}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        state:'',
        slotText:'',
        slotSmall:''
    },
    data(){
        return {
            activated:false,
            longpress:false,
            timer:null,
            longtarget:null,
            increm:null,
            progress:0

        }
    },
    watch:{
        progress(value){
            if(value >= 100){
                this.activated = true;
                this.$emit('activated',true);
            }else{
                return ;
            }
                
        }
    },
    methods:{
        start(e){
            var self = this;
            if (e.type === "click" && e.button !== 0) {
                console.log('Returning... detect click event');
                return;
            }
            this.longpress = false;
            this.timer = setTimeout(function () {
                self.increm = setInterval(function () {
                    self.progress+=5;
                }, 100);
            }, 10);
            return false;
        },
        cancel(e){
            console.log('cancel triggered');
            clearTimeout(this.timer);
            clearInterval(this.increm);
            this.progress = 0;
        },click(){
            console.log('click triggered');
        }

    }
}
            //http://jsfiddle.net/s77vsLxp/
            

            
            /*
            node.addEventListener("mousedown", start);
            node.addEventListener("touchstart", start);
            node.addEventListener("click", click);
            node.addEventListener("mouseup", cancel);
            node.addEventListener("mouseout", cancel);
            node.addEventListener("touchend", cancel);
            node.addEventListener("touchleave", cancel);
            node.addEventListener("touchcancel", cancel);
            */
</script>

